<template>
  <div class="chatroom" v-if="room && room.seller">
    <input
      type="file"
      :ref="`file`"
      :accept="$accept_file_type.image + ',' + $accept_file_type.video"
      onclick="this.value = null"
      @change="uploadFile"
    />
    <v-overlay z-index="99" :opacity=".9" :value="overlay.active" @click.native="overlay.active = false">
      <v-img
        contain
        v-if="overlay.active"
        :src="overlay.src"
        class="no-background"
        width="90vw"
        height="90vh"
        max-width="800px"
        max-height="800px"
        :transition="overlay.isGift ? 'scale-transition' : null"
        origin="center center"
        :style="[overlay.isGift ? {'border-radius': '10px'} : '']"
      ></v-img>
    </v-overlay>

    <CustomizeHeader right>
      <div slot="left">
        <v-menu bottom  nudge-right="15" :close-on-content-click="false" content-class="profile-card">
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex align-center" v-bind="attrs" v-on="on">
              <v-avatar size="35" class="ml-4">
                <v-img :src="$HOST_URL + room.seller.usericon"/>
              </v-avatar>
              <div class="nickname mx-2">{{ room.seller.nickname }}</div>
              <v-icon small>expand_more</v-icon>
            </div>
          </template>
          <v-card class="pa-4">
            <v-list-item class="pa-0 mb-4">
              <v-list-item-avatar size="50" tile>
                <v-avatar tile>
                  <v-img :src="$HOST_URL + room.seller.usericon"/>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-regular mb-1">
                  {{ room.seller.nickname }}
                </v-list-item-title>
                <v-rating
                  x-small
                  dense
                  readonly
                  half-increments
                  :value="5"
                  background-color="yellow darken-2"
                  color="yellow darken-2"
                ></v-rating>
              </v-list-item-content>
            </v-list-item>
            <div class="information">
              <div>地區</div>
              <div>{{ room.seller.city }}</div>
            </div>
            <div class="information">
              <div>身高</div>
              <div>{{ room.seller.height }}</div>
            </div>
            <div class="information">
              <div>身材</div>
              <div>{{ `${room.seller.bust}${room.seller.cup}/${room.seller.waist}/${room.seller.hips}` }}</div>
            </div>
            <div class="information">
              <div>職業</div>
              <div>{{ (seller_job_types.find(type => type.id == room.seller.job) || {}).name || '-' }}</div>
            </div>
            <v-btn block dark class="mt-4" :to="`/seller/${room.seller.id}`">查看個人資料</v-btn>
            <span @click="$store.dispatch('user/follow', room.seller.id)">
              <v-btn v-if="!isFollow" dark block color="pink" class="d-block mx-auto mt-4">追蹤對方</v-btn>
              <v-btn v-else dark block outlined color="pink" class="d-block mx-auto mt-4">追蹤中</v-btn>
            </span>
            <span @click="$store.dispatch('user/block', room.seller.id)">
              <v-btn v-if="!isBlock" dark block color="red darken-2" class="d-block mx-auto mt-4">封鎖</v-btn>
              <v-btn v-else dark block outlined color="red darken-2" class="d-block mx-auto mt-4">已封鎖</v-btn>
            </span>
          </v-card>
        </v-menu>
      </div>
      <template slot="right">
        <v-btn icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>
    </CustomizeHeader>
    <div class="chat-container">
      <div class="body" ref="body" v-infinite-scroll="getChatRecords" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-reverse>
        <div
          v-for="record in records"
          :key="record.id"
          :class="['message', record.sender === 'seller' ? 'a' : 'b']"
        >
          <div class="text" v-once v-if="record.type == 'text'">
            {{ record.text }}
          </div>
          <div class="gift" v-else-if="record.type == 'gift'">
            送出一個
            <img 
              v-once
              :src="$HOST_URL + record.gift.image_path"
            ></img>
          </div>
          <img 
            v-else-if="record.type == 'image'"
            v-once
            :src="record.image_path.startsWith('blob') ? record.image_path : $HOST_URL + record.image_path"
            @click="overlay = {active: true, src: record.image_path.startsWith('blob') ? record.image_path : $HOST_URL + record.image_path, transition: false}"
          ></img>
          <audio 
            v-else-if="record.type == 'audio'"
            :src="record.audio_path.startsWith('blob') ? record.audio_path : $HOST_URL + record.audio_path" 
            controls 
            controlsList="nodownload noplaybackrate"
            type="audio/wav"
          ></audio>
          <v-responsive 
            v-else-if="record.type == 'video'"
            :width="$vuetify.breakpoint.xsOnly ? 300 : 400"
            :max-width="$vuetify.breakpoint.xsOnly ? 300 : 400" 
            :max-height="$vuetify.breakpoint.xsOnly ? 200 : 300"
          >
            <video-player
              class="video-player vjs-big-play-centered" 
              v-once
              :playsinline="true" 
              :options="$func.videoOption({
                src: record.video_path.startsWith('blob') ? record.video_path : $HOST_URL + record.video_path,
                type: record.video_type,
                bigPlayButton: true,
                autoplay: false,
                loop: false,
                controls: true,
              })"></video-player>
          </v-responsive>
          <v-card 
            v-else-if="record.type == 'product'"
            class="story-item" 
            flat 
            @click="$root.$emit('story', room.seller, record.product, record.product.product_type)"
          >
            <v-img
              :src="$func.productImagePreview(record.product)"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.4)"
              width="150px"
              aspect-ratio="0.75"
              class="align-end"
            >
              <div class="description" :title="record.product.title">{{ record.product.title }}</div>
            </v-img>
          </v-card>
          <span class="created_at" v-if="$func.dayDiff(record.created_at) === 0">
            今天 {{ record.created_at | time }}
          </span>
          <span class="created_at" v-else-if="$func.dayDiff(record.created_at) === 1">
            昨天 {{ record.created_at | time }}
          </span>
          <span class="created_at"  v-else-if="$func.isThisYear(record.created_at)">
            {{ record.created_at | dateTime }}
          </span>
          <span class="created_at"  v-else>{{ record.created_at | dateTime }}</span>
        </div>
      </div>
      <v-expand-transition>
        <v-card class="gift-container" v-show="giftPicker">
          <v-btn icon dark absolute top right @click="giftPicker = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-row >
            <v-col
              class="gift"
              cols="4" 
              sm="3" 
              md="2" 
              lg="1" 
              xl="1" 
              v-for="gift in gifts"
              :key="gift.id"
              @click="sendMessage('gift', gift)"
            >
              <v-img :src="$HOST_URL + gift.image_path" aspect-ratio="0.6"></v-img>
              <div class="price">
                <div class="peach"></div>
                {{ gift.price }}
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-expand-transition>
      <div class="action">
        <div class="audio-timer" :style="`width: ${recordingTime / $audio_length.max * 100}%`"></div>
        <v-btn icon color="pink" class="mr-2" @click="giftPicker = !giftPicker">
          <v-icon>fa-gift</v-icon>
        </v-btn>
        <v-menu nudge-top="80" nudge-left="8" content-class="attach elevation-0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark class="mr-2" v-on="on">
              <v-icon>fa-paperclip</v-icon>
            </v-btn>
          </template>
          <v-btn icon dark x-large class="purple elevation-6" @click="$refs.file.click()">
            <v-icon size="25">fa-image</v-icon>
          </v-btn>
        </v-menu>
        <div class="input-block">
          <div v-if="isRecording">
            {{ $moment.utc(recordingTime * 1000).format('mm:ss') }}
          </div>
          <template v-else>
            <v-textarea
              v-model="text"
              ref="text"
              solo
              rounded
              dense
              hide-details
              auto-grow
              no-resize
              rows="1"
              @keydown.enter="sendMessage('text', text)"
            ></v-textarea>
            <div v-if="!text && room.seller" class="hint" @click="$refs.text.focus()">
              花費<div class="peach ml-1"></div><div class="pink--text mr-1">{{ room.seller.chat_price }}</div>發送聊天
            </div>
          </template>
        </div>
        <v-btn v-if="text" icon color="pink" class="ml-2" @click="sendMessage('text', text)">
          <v-icon>send</v-icon>
        </v-btn>
        <v-btn v-else icon dark class="ml-2">
          <v-icon v-if="!isRecording" @click="$store.dispatch('recorder/startRecording')">fa-microphone</v-icon>
          <v-icon v-else color="red" @click="$store.dispatch('recorder/stopRecording', $refs.chatroomUploadFile.open)">fa-stop</v-icon>
        </v-btn>
      </div>
    </div>
    <ChatroomUploadFile ref="chatroomUploadFile" @send="file => sendMessage(file.type.split('/')[0], file)"></ChatroomUploadFile>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CustomizeHeader from '@/components/CustomizeHeader'
import ChatroomUploadFile from '@/components/ChatroomUploadFile'
export default {
  props: ['room'],
  components: { CustomizeHeader, ChatroomUploadFile },
  data() {
    return {
      busy: false,
      page: 1,
      text: '',
      recorder: null,
      overlay: {active: false},
      giftPicker: false,
      gifts: [],
      records: []
    }
  },
  channel() {
    return `private:member.${ this.user.id }`
  },
  echo: {
    SendToChat(response) {
      this.records.push(response.message)
      this.scrollToBottom()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('recorder/stopRecording')
    next()
  },
  created() {
    if(!this.room || !this.room.seller) {
      this.$router.push('/chats')
    }
  },
  mounted() {
    this.markRead()
    this.getGiftsList()
    // document.getElementsByClassName('chatroom')[0].style.height = window.innerHeight + 'px'
  },
  computed: {
    ...mapState('global', ['seller_job_types']),
    ...mapState('user', ['user', 'followList', 'blockList']),
    ...mapState('recorder', ['isRecording', 'recordingTime']),
    ...mapGetters('user', ['purchaseID']),
    isFollow() {
      return this.followList.map(seller => seller.id).includes(this.room.seller.id)
    },
    isBlock() {
      return this.blockList.map(seller => seller.id).includes(this.room.seller.id)
    },
  },
  watch: {
    recordingTime() {
      if(this.recordingTime >= this.$audio_length.max) {
        this.$store.dispatch('recorder/stopRecording', this.$refs.chatroomUploadFile.open)
      }
    }
  },
  methods: {
    getChatRecords() {
      if (!this.room || !this.room.id) {
        this.busy = true
        return Promise.resolve()
      }
      this.busy = true
      return this.axios(`/member/chat/${this.room.id}/message?page=${this.page}&size=50`).then(async response => {
        this.records.unshift(...response.data.data.reverse())
        console.log(this.records)
        if(this.page == 1) {
          await this.scrollToBottom(true)
        }
        else {
          await this.adjustScrollTop(this.$refs.body.scrollHeight, this.$refs.body.scrollTop)
        }
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
    markRead() {
      if(this.room && this.room.id) {
        this.axios.put(`/member/chat/${this.room.id}/read`)
      }
    },
    async uploadFile() {
      let file = event.target.files[0]
      if(!await this.$func.fileValidation(file, 'chatroom_member')) {
        return
      }
      this.$refs.chatroomUploadFile.open(file)
    },
    scrollToBottom(first = false) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          if(first) {
            Promise.all(
              [...this.$refs.body.getElementsByTagName('img')]
              .map(async img => {
                return new Promise(resolve => { 
                  let interval = setInterval(() => {
                    if(img.naturalWidth > 0 && img.naturalHeight > 0) {
                      clearInterval(interval)
                      resolve()
                    }
                  }, 100)
                })
              })
            )
            .then(() => {
              this.$refs.body.scrollTop = this.$refs.body.scrollHeight
              this.$refs.body.style.visibility = 'visible'
              resolve()
            })
          }
          else {
            this.$refs.body.scrollTop = this.$refs.body.scrollHeight
            resolve()
          }
        })
      })
    },
    // prevent auto scroll when prepend records
    adjustScrollTop(prev_height, prev_top) {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.$refs.body.scrollTop = this.$refs.body.scrollHeight - (prev_height - prev_top)
          resolve()
        })
      })
    },
    getGiftsList() {
      this.axios('/chat/gift').then(response => {
        this.gifts = response.data
      })
    },
    sendGift(gift) {
      this.giftPicker = false
      this.sendMessage('gift', gift.id).then(() => {
        // this.giftAnimation(gift)
      })
    },
    giftAnimation(gift) {
      this.overlay = {active: true, src: this.$HOST_URL + gift.image_path, isGift: true}
      setTimeout(() => {
        this.overlay.active = false
      }, 4000)
    },
    sendMessage(type, data) {
      // shift + enter for new line
      if(event && event.keyCode == 13 && event.shiftKey) {
        return
      }
      if(event && event.preventDefault) {
        event.preventDefault()
      }
      // Don't send empty text
      if(type === 'text' && (!data || data.trim() === '')) {
        return
      }
      let formData = new FormData()
      formData.append('type', type)
      if(['text', 'image', 'video'].includes(type)) {
        formData.append(type, data)
      }
      else if(type == 'audio') {
        formData.append(type, data, 'audio.wav')
      }
      else if(type == 'gift') {
        formData.append(`${type}_id`, data.id)
      }
      let payload = {
        url: `/member/chat/${this.room.seller.id}`,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      }
      return this.axios(payload).then(response => {
        if(type == 'text') {
          this.text = ''
        }
        let record = {type: type}
        if(type == 'text') {
          record[`text`] = data
        }
        else if(['image', 'video', 'audio'].includes(type)) {
          record[`${type}_path`] = URL.createObjectURL(data)
          record[`${type}_type`] = data.type
        }
        else if(type == 'gift') {
          let gift = {image_path: data.image_path}
          record['gift'] = gift
          // this.giftAnimation(data)
          this.giftPicker = false
        }

        this.records.push(record)
        this.scrollToBottom()
        this.$store.dispatch('user/getUserInformation')
      }).catch(e => {
        if(e.response.data.message.includes('peaches not enough')) {
          this.$root.$emit('errorDialog', ['桃子不足，請先進行充值', {type: 'btn', text: '立即充值', action: () => this.$root.$emit('peachList')}])
        }
        else {
          this.$root.$emit('alert', 'error', '發送失敗')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
html {
  // overflow-y: hidden;
  // max-height: calc(100vh - 115px);
}
.attach {
  .v-btn {
     display: block;
     margin: 8px 0;
  }
}
.chatroom {
  // max-height: calc(100vh - 175px);
  .chat-container {
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
  }
  .v-overlay__content {
    max-width: 100%;
  }
}
</style>